
export type DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetEngagementAllOfTwo = {
  /** 인용 트윗 수 */
  quoteCount?: number;
  /** 답글 수 */
  replyCount?: number;
  /** 리트윗 수 */
  retweetCount?: number;
};
